module.exports = __webpack_public_path__ + "img/woshi.f7a2fa19.png";